import { Modal } from '@/components/common/dialog';
import { DiamondAlertIcon } from '@/components/icons';
import { useTranslation } from 'react-i18next';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export const EmptyCategoryPoiItem = ({ isOpen, onClose }: Props) => {
    const { t } = useTranslation();
    return (
        <Modal isOpen={isOpen} onClose={onClose} className="bg-bg-white max-w-[calc(620*var(--vh-unit))] py-[calc(40*var(--vh-unit))]">
            <section className="flex flex-col items-center justify-center gap-[calc(36*var(--vh-unit))]">
                <div className="text-not-contrast-red-fd2323 contrast:text-not-contrast-yellow-dceb2a flex w-full items-center justify-center">
                    <DiamondAlertIcon fill="currentColor" />
                </div>
                <p className="text-text-main01 text-center text-[calc(26*var(--vh-unit))] font-medium">
                    {t('floor_guide.message.your_corresponding_store_does_not_exist')}
                </p>
            </section>
        </Modal>
    );
};
